export default __webpack_public_path__ + "static/char-s-45-ko-f5c476ffcca89d0f3f3a96103e72242a.png";